import f from "./index.es300.js";
function m(r, e) {
  return g(r) || d(r, e) || p(r, e) || b();
}
function b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p(r, e) {
  if (r) {
    if (typeof r == "string") return s(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? s(r, e) : void 0;
  }
}
function s(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function d(r, e) {
  var t = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t != null) {
    var n, o, l, a, i = [], u = !0, c = !1;
    try {
      if (l = (t = t.call(r)).next, e !== 0) for (; !(u = (n = l.call(t)).done) && (i.push(n.value), i.length !== e); u = !0) ;
    } catch (y) {
      c = !0, o = y;
    } finally {
      try {
        if (!u && t.return != null && (a = t.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return i;
  }
}
function g(r) {
  if (Array.isArray(r)) return r;
}
function v(r) {
  return r.length === 0 ? "" : '<mergeCells count="'.concat(r.length, '">') + r.map(function(e) {
    var t = m(e, 2), n = t[0], o = t[1], l = f(n[1], n[0] + 1) + ":" + f(o[1], o[0] + 1);
    return '<mergeCell ref="'.concat(l, '"/>');
  }).join("") + "</mergeCells>";
}
export {
  v as default
};
//# sourceMappingURL=index.es267.js.map
